import { useGetUserQuery } from "../api";
import { AppRoutes, UserRoles } from "../types/enums";
import { Navigate } from "react-router-dom";
import { history } from "../utils/history";
import { Stack, Typography } from "@mui/material";
import { MainWrapper } from "../components/ui";
import { AverageScores, ReviewsPageBody } from "../components/reviews";

const ReviewsPage = () => {
  const { data: user } = useGetUserQuery();

  if (!user) return null;

  if (!user?.roles.includes(UserRoles.admin)) {
    return (
      <Navigate to={AppRoutes.CAMPAINGS} state={{ from: history.location }} />
    );
  }

  return (
    <MainWrapper>
      <Stack gap="16px">
        <Typography variant="h4" fontWeight={500} color="custom.textDarkBlue">
          Reviews
        </Typography>
        <AverageScores />
      </Stack>
      <ReviewsPageBody />
    </MainWrapper>
  );
};

export default ReviewsPage;
